import { SocialShareConfiguration } from "../uiModel/socialShare/SocialShareConfiguration";

const facebookShareUrl = (pageUrl: string) => `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
const twitterShareUrl = (pageUrl: string) => `https://twitter.com/intent/tweet?text=${pageUrl}`;

const getPageUrl = () => {
  try {
    return window.top.location.href;
  } catch {
    // different domain - we cannot access window url
    return undefined;
  }
};

const getShareConfiguration: () => SocialShareConfiguration = () => {
  const pageUrl = getPageUrl();
  if (pageUrl) {
    return {
      canShare: true,
      facebookUrl: facebookShareUrl(pageUrl),
      twitterUrl: twitterShareUrl(pageUrl)
    };
  } else {
    return {
      canShare: false
    };
  }
};

export const SocialShareHelper = {
  getShareConfiguration
};